import { makeAutoObservable } from "mobx";
import { isGroupIdResponseDTO } from "./GroupId";
import {
  GroupStudentResponseApi,
  isGroupStudentResponseDTO,
} from "./GroupStudent";
import {
  GroupModuleResponseApi,
  isGroupModuleResponseDTO,
} from "./GroupModule";

export interface GroupResponseApi {
  groupId: string;
  groupCode: string;
  groupName: string;
}

export let isGroupResponseDTO = (
  variable: unknown
): variable is GroupResponseApi => {
  return (
    isGroupIdResponseDTO(variable) &&
    "groupName" in variable &&
    typeof variable.groupName === "string" &&
    "groupCode" in variable &&
    typeof variable.groupCode === "string"
  );
};

export interface GroupWithStudentsAndModulesResponseApi
  extends GroupResponseApi {
  groupStudents: GroupStudentResponseApi[];
  groupModules: GroupModuleResponseApi[];
  groupLearningPathName?: string;
}

export let isGroupWithStudentsAndModulesResponseDTO = (
  variable: unknown
): variable is GroupWithStudentsAndModulesResponseApi => {
  return (
    isGroupResponseDTO(variable) &&
    (!("groupLearningPathName" in variable) ||
      typeof variable.groupLearningPathName === "string") &&
    "groupStudents" in variable &&
    Array.isArray(variable.groupStudents) &&
    (variable.groupStudents.length === 0 ||
      variable.groupStudents.reduce(
        (doArrayConsistOfStudents, groupStudent) =>
          doArrayConsistOfStudents && isGroupStudentResponseDTO(groupStudent)
      )) &&
    "groupModules" in variable &&
    Array.isArray(variable.groupModules) &&
    (variable.groupModules.length === 0 ||
      variable.groupModules.reduce(
        (doArrayConsistOfModules, groupModule) =>
          doArrayConsistOfModules && isGroupModuleResponseDTO(groupModule)
      ))
  );
};

export class EmptyGroupResponseImpl
  implements GroupWithStudentsAndModulesResponseApi
{
  groupModules: GroupModuleResponseApi[] = [];
  groupStudents: GroupStudentResponseApi[] = [];
  groupId: string = "";
  groupCode: string = "";
  groupName: string = "";
}

export class ObservableGroupPropImpl {
  groupName: string;

  constructor(group: GroupResponseApi) {
    this.groupName = group.groupName;
    makeAutoObservable(this);
  }

  onChangeName = (groupName: string) => {
    this.groupName = groupName;
  };
}
